import { Sign } from "../../cores/me/interfaces/api/get-meSign";

export const addSign = (message: string, sign: Sign) => `${message}${sign.sign}`;
